import { AdvancedSettingsVirtualStepValue, VMQuiesceType } from 'wizards/models/advanced-settings-vm-models';
import { SelectHostStepValue } from 'wizards/models/select-host-models';
import { VmwareHyperVBaseModel } from '../base/vmware-hyper-v-base-model';

export class VmwareFormModel extends VmwareHyperVBaseModel {
  advancedSettingsStep: AdvancedSettingsVirtualStepValue = {
    quiesceType: VMQuiesceType.TryApplicationConsistent,
    useChangeBlockTracking: true,
    useS3Acceleration: false,
    storageClass: 1,
    syntheticFull: true,
    valid: true
  };
  AvailableMachinePlans: any[] = [];
  selectHostStep: SelectHostStepValue = { server: '', login: '', password: '', remember: true, valid: true };

  constructor(
    public isUnix = false,
    public isNBF = false
  ) {
    super(isUnix, isNBF);
  }
}
